import React from "react";

interface TabsType {
  type?: "Type 1" | "Small Tabs";
  tabs: Array<String>;
  selected: String;
  setSelected: Function;
}

const Tabs: React.FC<TabsType> = ({
  type = "Type 1",
  tabs,
  selected,
  setSelected,
}) => {
  return (
    <div
      className={type === "Type 1" ? "tabs-wrapper" : "tabs-wrapper small-tabs"}
    >
      <ul>
        {tabs.map((item, index) => (
          <li
            key={`tab-item-${item}-${index}`}
            className={`tab-item ${selected === item ? "active-tab" : ""}`}
            onClick={() => setSelected(item)}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Tabs;
